import { Shadow, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { ResponsesStatementFixedIncomeResponse } from '@genial/services/dist/models';
import { Utils } from '@genial/utils';
import React, { useState } from 'react';

import { LateralBar } from '../../../../../../../NewApplication/Product/components/LateralBar';

import { DetailsList } from './components/DetailsList';
import { Header } from './components/Header';
import { messageError } from './constants';

interface FixedIncomeItemProps {
  data: ResponsesStatementFixedIncomeResponse;
}

export const FixedIncomeItem: React.FC<FixedIncomeItemProps> = ({ data }) => {
  const [isOpened, setIsOpened] = useState(false);
  const title = data?.statementFixedIncome?.issuerName || messageError;
  const maturityDate = data?.statementFixedIncome?.maturityDate
    ? Utils.Mask.DateFormat(data.statementFixedIncome.maturityDate, 'dd/MM/yyyy')
    : messageError;

  return (
    <Shadow
      marginBottom={Spacing['inset.nano']}
      level={3}
      borderRadius={BoxRadius.sm}
      my={Spacing['inline.nano']}>
      <VStack borderRadius={BoxRadius.sm}>
        <LateralBar
          backgroundColor={Color['product.rf']}
          borderTopLeftRadius={BoxRadius.sm}
          borderBottomLeftRadius={BoxRadius.sm}
        />
        <VStack p={Spacing['inline.xxxs']} space={Spacing['inline.xxxs']}>
          <Header
            handleOpenInfo={() => setIsOpened((state) => !state)}
            isOpened={isOpened}
            maturityDate={maturityDate}
            title={title}
          />
          {isOpened && <DetailsList data={data} />}
        </VStack>
      </VStack>
    </Shadow>
  );
};
